import { createAsyncThunk, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit'
import { Auth } from 'aws-amplify';
import { RootState } from '../../../store/store';
import { Loading, NameAttributes } from '../../../App/app';
import { feedback } from '../../../components/Feedback/feedback';
import i18n from '../../../i18n/i18n';
import  apiMessage from "../../../i18n/api/api-messages";

export interface State {
  currentRequestId: string,
  error: SerializedError | null,
  loading: Loading,
}

const initialState: State = {
  currentRequestId: '',
  error: null,
  loading: 'idle',
}

export const updateNameAttributes = createAsyncThunk(
  'userInformation/updateUserInformation',
  async ( attributes: NameAttributes, thunkAPI ) => {
    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.pages.settings.userInformation;

    if (loading !== 'pending' || thunkAPI.requestId !== currentRequestId) return

    return Auth.currentAuthenticatedUser().then( cognitoUser => {
      return Auth.updateUserAttributes( cognitoUser, attributes )
        .then( ( data ) => {
          const settingsT = i18n.getFixedT( null, 'settings');
          thunkAPI.dispatch( feedback({ message: settingsT('user-information-saved') , severity: 'success' } ));
        });
    }).catch( error => {
      const apiT = i18n.getFixedT( null, 'api' );
      thunkAPI.dispatch( feedback( { message: apiT(apiMessage( error.message )), severity: 'error' } ));
    })

  }
)

export const userInformationSlice = createSlice({
  name: 'userInformation',
  initialState,
  reducers: {
  },
  extraReducers: ( builder ) => {
    builder.addCase( updateNameAttributes.pending, (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending'
        state.currentRequestId = action.meta.requestId
      }
    })
    .addCase( updateNameAttributes.fulfilled, (state, action) => {
      const { requestId } = action.meta
      if ( state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle'
        // state.entities.push(action.payload)
        state.currentRequestId = ''
      }
    })
    .addCase( updateNameAttributes.rejected, ( state, action, ) => {
      const { requestId } = action.meta
      if (
        state.loading === 'pending' &&
        state.currentRequestId === requestId
      ) {
        state.loading = 'idle'
        state.error = action.error
        state.currentRequestId = ''
      }
    })
  }
})

export const {} = userInformationSlice.actions

export default userInformationSlice.reducer
